import type { SavedEmailTemplate } from "@redotech/redo-model/saved-email-template";
import { savedEmailTemplateSchema } from "@redotech/redo-model/saved-email-template";
import { SortDirection } from "@redotech/redo-model/tables/table";
import * as z from "zod/v4";

export const getSavedEmailTemplates = {
  name: "getSavedEmailTemplates" as const,
  input: z.object({ sortDirection: z.enum(SortDirection).optional() }),
  output: z.object({
    data: z.array(savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>),
    paginationKey: z.string().optional(),
  }),
};
